<template>
  <b-row class="mb-32">
    <b-col cols="12" class="mb-32">
      <b-row align-v="center" align-h="between">
        <div>
          <h3>Welcome back, Agent 👋</h3>
          <p class="hp-p1-body mb-0">
            Your current status and analytics are here
          </p>
        </div>
      </b-row>
    </b-col>

  </b-row>
</template>

<script>
import { BRow, BCol, BCard ,BAvatar} from "bootstrap-vue";
import axios from "axios";
import CustomerFeatureCard from "../../widgets/cards/advance/CustomerFeatureCard.vue";
import OrdersFeatureCard from "../../widgets/cards/advance/OrdersFeatureCard.vue";
import SaleFeatureCard from "../../widgets/cards/advance/SaleFeatureCard.vue";
import ProfitFeatureCard from "../../widgets/cards/advance/ProfitFeatureCard.vue";
import RevenueColumnCard from "../../widgets/cards/analytics/RevenueColumnCard.vue";
import CtaCardTwo from "../../widgets/cards/advance/CtaCardTwo.vue";
import RevenueCard from "../../widgets/cards/statistics/RevenueCard.vue";
import BrowserStates from "./BrowserStates.vue";
import EarningsCard from "./EarningsCard.vue";
import LatestOrders from "./LatestOrders.vue";
import CheckDetailCard from "./CheckDetailCard.vue";
import BestSellingProducts from "./BestSellingProducts.vue";

export default {
  data() {
    return {
      totalTheftVehicles: 0,
      totalRecoverVehicles: 0,
      total_market_place: 0,
      total_vehicles: 0,
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    CustomerFeatureCard,
    OrdersFeatureCard,
    SaleFeatureCard,
    ProfitFeatureCard,
    RevenueColumnCard,
    CtaCardTwo,
    RevenueCard,
    BrowserStates,
    EarningsCard,
    LatestOrders,
    CheckDetailCard,
    BestSellingProducts,
  },
  mounted() {
    this.getDashboardDataManager();
  },
  methods: {
    async getDashboardDataManager() {
      try {
          this.managerId = localStorage.getItem("userId");
        const response = await axios.get("/dashboardManger/"+ this.managerId);
        if (response.data.success) {
          this.totalTheftVehicles = response.data.data.total_theft_vehicles;
          this.totalRecoverVehicles = response.data.data.total_recover_vehicles;
          this.total_vehicles = response.data.data.total_vehicles;
          this.total_market_place = response.data.data.total_market_place;
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    },
  },
};
</script>
